<template>
  <div class="">
    <NavMenu/>
    <header class="masthead" style="bottom: -60px;">
      <div class="container px-md-5 px-4">
        <div class="">
          <div class="row">
            <div class="col-md-6 px-lg-5 px-3">
              <div class="header-content">
                <vue-typed-js :loop="true" :showCursor="false" :strings="['I am Oracle.', 'I empower people and businesses with state-of-the-art AI innovations.']">
                  <h1 class="typing mb-4" style="line-height: 1.3em;"></h1>
                </vue-typed-js>

                <div class="d-sm-block d-none">
                  <div class="mt-5 d-flex">
                    <!-- <a class="btn btn-light btn-lg mr-3 text-dark" href="/signup">Get Started</a> -->
                    <a class="btn btn-outline-light btn-lg" href="#explore"> See our Demo</a>
                  </div>

                </div>
                <!-- 
                <div class="d-sm-none d-block">
                  <div class="mt-5">
                    
                    <button class="btn btn-light btn-block btn-lg mr-3 mb-3">Get Started</button>
                    <button class="btn btn-outline-light btn-block btn-lg"> Watch Demo</button>
                  </div>
                </div> -->
              </div>
              

            </div>

            <div class="col-md-6 d-sm-block d-none" style="margin-top: -70px;">
              <div class="">
                <img src="@/assets/illustrations/ai-yellow.png" alt="" style="width: 650px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section id="explore" style="background: #fff;">
      <div class="container py-5">
        <div class="pt-5">
          <div class="col mb-3 pb-5 text-center">
            <h2 class="text-center">Explore what I can do...</h2>
            <p class="text-center">Dive in to interactive demos that showcase a selection of the capabilities of the AI Oracle.</p>
      
          </div>
          <div class="row mb-5">
            <div class="col-md-4 text-center mb-5">
              <div class="icon">
                    <img src="@/assets/illustrations/spam-yellow.png" alt="" style="width: 50px;" >
                  </div>
                <h3 class="mb-5">Image Transformer</h3>
              <div class="mt-3">
                <p class="mb-5 lh-2 font-weight-normal">Turn your photos into stunning styles. Go from photo to Cartoon, Anime, Painting styles in one click</p>
                <a class="btn btn-moneypool lh35 mb-4" href="https://pixtostyle.com" target="_blank">Try it out</a>
              </div>
              
            </div>
            <div class="col-md-4 text-center mb-5">
              <div class="icon">
                    <img src="@/assets/illustrations/construction.svg" alt="" style="width: 80px;" >
                  </div>
                <h3 class="mb-5">Vest Predictor</h3>
              <div class="mt-3">

                <p class="mb-5 lh-2 font-weight-normal">Safety vest detection project for ensuring workers safety in construction sites and workshops.
                </p>
                <router-link class="btn btn-moneypool lh35 mb-4" to="/vest">Try it out</router-link>
              </div>
            </div>
            <div class="col-md-4 text-center mb-5">
              <div class="icon">
                    <img src="@/assets/illustrations/helmet-yellow.png" alt="" style="width: 80px;" >
                  </div>
                <h3 class="mb-5">Helmet Predictor</h3>
              <div class="mt-3">

                <p class="mb-5 lh-2 font-weight-normal">Safety Helmet detection project for enforcing safety in construction sites and workshops.
                </p>
                <router-link class="btn btn-moneypool lh35 mb-4" to="/helmet">Try it out</router-link>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-4 text-center mb-5">
              <div class="icon">
                    <img src="@/assets/illustrations/mask.svg" alt="" style="width: 50px;" >
                  </div>
                <h3 class="mb-5">Facemask Predictor</h3>
              <div class="mt-3">
                <p class="mb-5 lh-2 font-weight-normal">The Face Mask Predictor AI detects persons with or without facemask to help the government to enforce compliance with health instructions as we fight the deadly the Covid19 virus.
                </p>
                <router-link class="btn btn-moneypool lh35 mb-4" to="/facemask">Try it out</router-link>
              </div>
              
            </div>
            <div class="col-md-4 text-center mb-5">
              <div class="icon">
                    <img src="@/assets/illustrations/messages.svg" alt="" style="width: 50px;" >
                  </div>
                <h3 class="mb-5">Spam Detector</h3>
              <div class="mt-3">
                                <p class="mb-5 lh-2 font-weight-normal">Spam detection project that identifies spam messages from real ones.</p>
                <a class="btn btn-moneypool lh35 mb-4" href="http://ehispamdetector.herokuapp.com/" target="_blank">Try it out</a>

                </div>
              
            </div>
          </div>

          <!-- <div class="col-12  mb-5 text-center">
            <p class="mb-5 font-weight-normal">
              Simplify your group collections today with Moneypool.
            </p>
            <a class="btn btn-moneypool lh35" href="/signup">Create a moneypool</a>
          </div> -->
        </div>
      </div>
    </section>
    <FooterArea/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavMenu from "../components/NavMenu";
import FooterArea from "../components/FooterArea";

export default {
  name: 'home',
  components: {
    NavMenu,
    FooterArea
  },
  // computed: {
  //   isAuth() {
  //     return this.$store.getters.isAuth;
  //   }
  // }

}
</script>

<style scoped>
  @import '../assets/css/one-page-wonder.css';

.lh35 {
  line-height: 3.5;
}
  header {
    background: #fff;
    /* background: url('../assets/illustrations/ai-yellow.png'); */

    /* align-: center; */
    /* background: transparent linear-gradient(270deg, #074053 0%, #03445a 43%, #04485f 100%) 0% 0% no-repeat padding-box; */
    }
  p.vesicash-moneypool__about {
    line-height: 2em;
  }
  .image-container {
    padding: 0;
    margin: 0;
    height: 100vh;
    background: url('../assets/people-background.png');
    background-repeat: no-repeat;
    background-size: cover;
}

.image-container .after {
    /* position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    color: #FFF;
}
.image-container .after {
    display: block;
    /* background: #540D6E 0% 0% no-repeat padding-box; */
    /* opacity: 0.59; */
}
.feature-box-04 .icon {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    border-radius: 50%;
    font-size: 28px;
    -webkit-transition: ease all 0.3s;
    -moz-transition: ease all 0.3s;
    -o-transition: ease all 0.3s;
    transition: ease all 0.3s;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background: #F4EEF6;
}
.btn-light, .btn-outline-light {
  border: 1px solid #074053 !important;
  height: 45px;
  line-height: 45px;
  color: #074053;
  padding: 0 30px !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 3px !important;
  font-weight: 500;
}
.theme-bg {
  /* background: #fff; */
  color: #fff;
}
</style>
